<template>
    <div class="questions-item">
        <p
            v-if="title"
            class="questions-item__title">
            {{ num }}. {{ title }}
        </p>

        <div
            v-if="list && list.length"
            :class="['questions-item__list', {'is-line': main}]">
            <template v-if="itemType === 'radio'">
                <STRadio
                    v-for="item in list"
                    :id="item.id"
                    :key="item.id"
                    v-model="questionItem"
                    :name="item.name"
                    :checked="item.checked"
                    :value="item.value">
                    {{ item.text }}
                </STRadio>
            </template>
            <template v-else-if="itemType === 'checkbox'">
                <STCheckbox
                    v-for="item in list"
                    :id="item.id"
                    :key="item.id"
                    v-model="questionItem"
                    :name="item.name"
                    :value="item.value">
                    {{ item.text }}
                </STCheckbox>
            </template>
        </div>
        <template v-if="itemType === 'textarea'">
            <textarea
                id="comfort-reason"
                v-model.trim="comfortReason"
                :class="[
                    'questions-item__textarea',
                    {'is-error': isOtherError}
                ]"
                name="comfort-reason"
                placeholder="Открытый комментарий" />
        </template>
        <textarea
            v-if="isShowTextarea"
            id="reason-detail"
            v-model.trim="questionTextarea"
            :class="[
                'questions-item__textarea',
                {'is-error': isOtherError}
            ]"
            name="reason-detail"
            :placeholder="computedPlaceholder" />
        <transition name="fade">
            <div v-if="isError ||
                     (itemType === 'checkbox' && isOtherError) || 
                     (name === 'willChange' && isOtherError)"
                 class="questions-item__error">
                <p>
                    <template v-if="!isOtherError">
                        {{ itemType === 'radio' ? 'Выберите один из вариантов' : 'Выберите один и более вариантов' }}
                    </template>
                    <template v-else>
                        Это обязательное поле
                    </template>
                </p>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'QuestionsItem',

    props: {
        num: {
            type   : String,
            default: ''
        },
        title: {
            type: String
        },
        name: {
            type: String
        },
        main: {
            type: Boolean
        },
        itemType: {
            type   : String,
            default: 'checkbox'
        },
        list: {
            type   : Array,
            default: () => []
        },
        isError: {
            type   : Boolean,
            default: false
        },
        isOtherError: {
            type   : Boolean,
            default: false
        },
        comfortableOtherPlaceholder: {
            type   : String,
            default: 'Открытый комментарий'
        },
        hasOtherField: {
            type   : Boolean,
            default: true
        }
    },

    data() {
        return {
            questionItem    : [],
            questionTextarea: '',
            isShowTextarea  : false,
            comfortReason   : '',
            placeholder     : ''
        };
    },

    computed: {
        computedPlaceholder() {
            return this.name === 'questionComfortable' ? this.comfortableOtherPlaceholder : this.placeholder;
        }

    },

    watch: {
        questionItem(value) {
            this.isShowTextarea = (this.itemType === 'checkbox' && value.includes('other')) ||
                                  (this.name === 'questionComfortable' && (value === 0 || value === '0') && this.hasOtherField);

            if (value.length && (!value.includes('other') || this.itemName === 'questionComfortable')) {
                this.questionTextarea = '';
            }

            this.$emit('change', {value, other: this.questionTextarea});
        },

        questionTextarea(text) {
            this.$emit('change', {value: this.questionItem, other: text});
        },

        comfortReason() {
            this.$emit('change', {value: this.questionItem, reason: this.comfortReason});
        }
    },

    mounted() {
        const textareaItem = this.list.find(item => this.itemType === 'checkbox' && item.value === 'other');

        if (textareaItem) {
            this.placeholder = textareaItem.otherText;
        }
    }
};
</script>

<style lang="scss">
@import "./QuestionsItem";
</style>